<ng-container *ngIf="product$ | async as product">
  <div class="cx-value-container">
    <div class="cx-thumbnail">
      <cx-media
        [container]="getProductPrimaryImage(product)"
        format="product"
        aria-hidden="true"
      ></cx-media>
    </div>
    <span class="cx-visually-hidden">
      {{ getAriaLabel() }}
    </span>
    <div class="cx-value-info" aria-hidden="true">
      <div>
        {{ attributeOverview.value }}
      </div>
      <span class="cx-code" *ngIf="attributeOverview?.productCode">
        {{ 'configurator.attribute.id' | cxTranslate }}:
        {{ attributeOverview.productCode }}</span
      >
      <div *ngIf="displayQuantity()" class="cx-quantity">
        <span class="cx-identifier">{{
          'configurator.attribute.quantity' | cxTranslate
        }}</span>
        <span class="cx-item">{{
          attributeOverview.quantity | cxNumeric
        }}</span>
      </div>
      <div *ngIf="displayPrice()" class="cx-price">
        <span class="cx-identifier">{{
          'configurator.overviewForm.itemPrice' | cxTranslate
        }}</span>
        <span class="cx-item">{{
          attributeOverview.valuePrice?.formattedValue
        }}</span>
      </div>
    </div>
  </div>

  <div class="cx-attribute-price-container" aria-hidden="true">
    <span class="cx-attribute-label">{{ attributeOverview.attribute }}</span>
    <cx-configurator-price
      [formula]="extractPriceFormulaParameters()"
    ></cx-configurator-price>
  </div>
</ng-container>
